// slider
var container = document.querySelector(".featured-coll");
var nextButton = document.querySelector(".next-arrow");
var prevButton = document.querySelector(".prev-arrow");

if (container && nextButton && prevButton) {
  // Calculate scroll amount based on the width of .option-color
  var slideWidth = document.querySelector(".coll-slide").offsetWidth;

  var scrollAmount = slideWidth + 10; // Adding 10px extra for padding or gap
  console.log("slideWidth", slideWidth);
  console.log("scrollAmount", scrollAmount);
  nextButton.addEventListener("click", function () {
    console.log("click");
    container.scrollBy({
      left: scrollAmount,
      behavior: "smooth",
    });
  });

  prevButton.addEventListener("click", function () {
    container.scrollBy({
      left: -scrollAmount,
      behavior: "smooth",
    });
  });
} else {
  // console.error('One or more elements not found:', { container, nextButton, prevButton });
}
